export enum EnvironmentType {
  Development = 'development',
  Production = 'production',
}
